module.exports = __webpack_public_path__ + "6cedccc71c7f856b69088d2977d285d7.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/termine/Velvetone.jpg
// module id = 723
// module chunks = 0